import React, { Component } from "react";
import { connect } from "react-redux";
import { loadUser } from "../action/authActions";

// components
import Header from "../components/Header";
import Links from "../components/Links";
import Posts from "../components/Posts";

class Home extends Component {
  componentWillMount() {
    this.props.loadUser();
  }

  render() {
    console.log(this.props.name);
    return (
      <React.Fragment>
        <Header />
        <div className="container mt-5">
          <div className="row">
            <div className="col-md-4">
              <Links />
            </div>
            <div className="col-md-5">
              <Posts />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  name: state.auth.user.name,
});

export default connect(mapStateToProps, { loadUser })(Home);
